import { useState } from 'react'
import axios from 'axios'

import { CONNECTION } from 'configs/configs.js'
import { IObject } from 'interfaces'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '.'

const useFetch = (endpoint = '/') => {
  const { token } = useAuth()
  const navigate = useNavigate()

  const [curEndpoint, setEndpoint] = useState<string>(endpoint)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const parseError = (error: any) => {
    const { response, isAxiosError } = error
    // console.clear()
    if (response && response.data) {
      const { data } = response
      console.error(data.message)
      return data || []
    }
    if (isAxiosError) {
      return { message: 'Falha ao enviar dados ao servidor' }
    }
    return []
  }

  // TODO - Acrescentei o parâmetro URL provisóriamente até descobrir o motivo
  // pelo qual o setEndpoint não estar funcionando
  const fetch = async (
    request: any,
    data?: any,
    url?: string,
    headers?: IObject
  ) => {
    const URL = `${CONNECTION.URL}${url || curEndpoint}`
    try {
      setIsLoading(true)
      const response = await axios({
        method: request.toLowerCase(),
        url: URL,
        data,
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
          'x-origin': CONNECTION.ORIGIN,
          'Cache-Control': 'no-cache', // Prevents caching by intermediaries
          Pragma: 'no-cache', // HTTP/1.0 backward compatibility
        },
      })
      return { data: response.data, fail: false }
    } catch (error: any) {
      setIsLoading(false)
      if (error.response?.status === 501 || error.response?.status === 498) {
        navigate('/login')
      }
      return {
        data: null,
        fail: true,
        errors: parseError(error),
        status: error.response?.status,
      }
    }
  }

  return {
    setEndpoint, // TODO - Por algum motivo, isto não está atualizando
    fetch,
    isLoading,
  }
}

export default useFetch
